import { React, useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ToastElement from "../../../../../Components/UiComponents/ToastElement";
import InputTextElement from "../../../../../Components/UiComponents/InputTextElement";
import SingleSelectElement from "../../../../../Components/UiComponents/SingleSelectElement";
import { addAddressFromPages } from "../../../../../Services/addressService";
import { getCustomerFields } from '../../../../../Services/fieldsServices';
import ButtonElement from "../../../../../Components/UiComponents/ButtonElement";
import Loader from "../../../../../Components/UiComponents/Loader";

export default function CreateNewAddress(props) {
    // const [errors, setErrors] = useState({});
    const [visible, setVisible] = useState(false);
    const [location, setLocation] = useState([]);
    const [address1, setAddress1] = useState([]);
    const [address2, setAddress2] = useState([]);
    const [officeNumber, setOfficeNumber] = useState([]);
    const [telephoneNumber, setTelephoneNumber] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [postcode, setPostcode] = useState([]);
    const [country, setCountry] = useState([]);
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false)
    const toastRef = useRef();

    useEffect(() => {

        if (props?.fieldDetail) {
            let filterDetails = props?.fieldDetail.filter(item => item.module_name === 'Common Fields')

            let field = filterDetails[0]?.sub_modules[0]?.fields
            if (field) {
                let location = field.filter(item => item.field_name === 'Location Name')
                let address1 = field.filter(item => item.field_name === 'Address Line 1')
                let address2 = field.filter(item => item.field_name === 'Address Line 2')
                let officeNumber = field.filter(item => item.field_name === 'Office Number')
                let telephoneNumber = field.filter(item => item.field_name === 'Telephone Number')
                let city = field.filter(item => item.field_name === 'City')
                let state = field.filter(item => item.field_name === 'State/County')
                let postcode = field.filter(item => item.field_name === 'Postcode')
                let country = field.filter(item => item.field_name === 'Country')


                setLocation(location)
                setAddress1(address1)
                setAddress2(address2)
                setOfficeNumber(officeNumber)
                setTelephoneNumber(telephoneNumber)
                setCity(city)
                setState(state)
                setPostcode(postcode)
                setCountry(country)
            }
        }

    }, [props?.fieldDetail]);

    useEffect(() => {
        getCustomer()
    }, [props?.customerId]);

    const getCustomer = async () => {
        // Check if customerId is provided
        if (props?.customerId !== null) {
            try {
                setLoading(true);
                // Fetch customer fields
                const response = await getCustomerFields(props.customerId);
                if(response && response.data){
                    // Extract reference data and filter for 'Country List'
                    let data = response.data?.reference_data || [];
                    let state = data.filter(item => item.display_name === 'Country List');

                    // Check if the state has data before accessing option_choice
                    if (state.length > 0) {
                        setCountries(state[0].option_choice);
                    } else {
                        toastRef.current.showToast({
                            type: 'warning',
                            message: 'No country data available.'
                        });
                    }
                }
                
            } catch (error) {
                // Show error toast notification if the API call fails
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Error fetching customer data. Please try again or contact Admin.'
                });
            } finally {
                // Stop loading spinner regardless of success or failure
                setLoading(false);
            }
        } 
    };
    

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    // Function to create new prompt
    const onSubmit = async (promptData) => {
        // Initialize data and ensure country is set
        let data = { ...promptData };
        data.country = data?.country?.label;
    
        try {
            // Make the API call to add an address
            const response = await addAddressFromPages(
                props?.clientId,
                props?.customerId,
                props?.clientName,
                "Client",
                data
            );
    
            // Check for successful response
            if (response && response?.status === 200) {
                toastRef.current.showToast({
                    type: "success",
                    message: "New Address Created Successfully",
                });
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: "Error creating address. Please try again.",
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred while creating the address. Please try again or contact Admin.",
            });
        } finally {
            closePopup();
        }
    };
    

    const closePopup = () => {
        reset();
        setVisible(false);
        props.onHide();
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
                    <ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit(onSubmit)} />
                </div>
            </div>
        );
    }

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <Dialog
                header={_.find(props.clientSectionsSummary, { section_name: "Client's Address" })?.display_name}
                visible={props.visible}
                position={props.position}
                onHide={() => {
                    closePopup();
                }}
                footer={renderFooter()}
                className="width-40vw"
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {
                            _.find(props.commonFields, { field_name: "Location Name" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {location[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="address_name"
                                        control={control}
                                        rules={{ required: "Location Name is required" }}
                                        render={({ field }) => (
                                            <InputTextElement id="address_name" {...field} />
                                        )}
                                    />
                                    {errors?.address_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.address_name.message}
                                        </small>
                                    )}
                                </div>

                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Address Line 1" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {address1[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="building_name"
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="building_name" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Address Line 2" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {address2[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="address_line_two"
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="address_line_two" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Office Number" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {officeNumber[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        id="office_addr_contact"
                                        name="office_addr_contact"
                                        control={control}
                                        rules={{
                                            pattern: {
                                                value: /^[+]?\d{1,4}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,9}$/,
                                                message: "Office number is not valid"
                                            }
                                        }}
                                        render={({ field }) => (
                                            <InputTextElement id="office_addr_contact" {...field} />
                                        )}
                                    />
                                    {errors?.office_addr_contact && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.office_addr_contact.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Telephone Number" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {telephoneNumber[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">  
                                    <Controller
                                        id="telephone_number"
                                        name="telephone_number"
                                        rules={{
                                            pattern: {
                                                value: /^[+]?\d{1,4}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,9}$/,
                                                message: "Telephone number is not valid"
                                            }
                                        }}
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="telephone_number" {...field} />
                                        )}
                                    />
                                    {errors?.telephone_number && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.telephone_number.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "City" })?.field_status &&
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {city[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="city"
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="city" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "State/County" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {state[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="state"
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="state" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Postcode" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {postcode[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="postcode"
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextElement id="postcode" {...field} />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Country" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {country[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="country"
                                        control={control}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="country"
                                                {...field}
                                                name="country"
                                                options={(countries != undefined && countries.length > 0) ? countries : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => field.onChange(e.value)}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </Dialog>
        </div>
    );
}
